import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';
import {ResidentViewModule} from '../../components/directory/detailed-view/resident-view/resident-view.module';

import {DirectoryComponent} from './directory.component';

import {ResidentsListComponent} from '../../components/directory/list/residents-list/residents-list.component';
import {UnitsListComponent} from '../../components/directory/list/units-list/units-list.component';
import {ParkingSpotsListComponent} from '../../components/directory/list/parking-spots-list/parking-spots-list.component';
import {LockersListComponent} from '../../components/directory/list/lockers-list/lockers-list.component';
import {VehiclesListComponent} from '../../components/directory/list/vehicles-list/vehicles-list.component';
import {PetsListComponent} from '../../components/directory/list/pets-list/pets-list.component';
import {BikeRacksListComponent} from '../../components/directory/list/bike-racks-list/bike-racks-list.component';

import {UnitViewComponent} from '../../components/directory/detailed-view/unit-view/unit-view.component';
import {ParkingSpotViewComponent} from '../../components/directory/detailed-view/parking-spot-view/parking-spot-view.component';
import {LockerViewComponent} from '../../components/directory/detailed-view/locker-view/locker-view.component';
import {VehicleViewComponent} from '../../components/directory/detailed-view/vehicle-view/vehicle-view.component';
import {PetViewComponent} from '../../components/directory/detailed-view/pet-view/pet-view.component';
import {BikeRackViewComponent} from '../../components/directory/detailed-view/bike-rack-view/bike-rack-view.component';

import {CreateModalModule} from '../../components/directory/create-modal/create-modal.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {DirectoryService} from '../../services/directory.service';
import {MoveOutModalModule} from '../../components/directory/move-out-modal/move-out-modal.module';
import {SendInvitationModalModule} from '../../components/directory/send-invitation-modal/send-invitation-modal.module';
import {AdminModule} from '../admin/admin.module';
import {ChangeUnitModalModule} from '../../components/directory/change-unit-modal/change-unit-modal.module';
import {AmenitiesModule} from '../amenities/amenities.module';
import {ParkingPassModule} from '../parking-pass/parking-pass.module';
import {AddInstructionsModalModule} from '../../components/directory/add-instructions-modal/add-instructions-modal.module';
import {AccountBalanceModalModule} from '../../components/directory/account-balance-modal/account-balance-modal.module';
import {VendorsListComponent} from '../../components/directory/list/vendors-list/vendors-list.component';
import {VendorViewComponent} from '../../components/directory/detailed-view/vendor-view/vendor-view.component';
import {UpdatesListComponent} from '../../components/directory/list/updates-list/updates-list.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {VendorsFilterComponent} from '../../components/vendors-filter/vendors-filter.component';
import {DirectoryArchivedItemsFilterComponent} from '../../components/directory-archived-items-filter/directory-archived-items-filter.component';
import {CaptureImageModalModule} from '../../components/directory/capture-image-modal/capture-image-modal.module';
import {SendSmsModalModule} from '../../components/directory/send-sms-modal/send-sms-modal.module';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        TabsModule,
        FormsModule,
        RouterModule,
        CommonComponentsModule,
        ResidentViewModule,
        FieldsModule,
        CreateModalModule,
        MoveOutModalModule,
        SendInvitationModalModule,
        AdminModule,
        ChangeUnitModalModule,
        AmenitiesModule,
        ParkingPassModule,
        AddInstructionsModalModule,
        AccountBalanceModalModule,
        AngularMaterialImportModule,
        AngularMultiSelectModule,
        CaptureImageModalModule,
        SendSmsModalModule,
        UtilsModule
    ],
    declarations: [
        DirectoryComponent,
        ResidentsListComponent,
        UnitsListComponent,
        ParkingSpotsListComponent,
        LockersListComponent,
        VehiclesListComponent,
        PetsListComponent,
        BikeRacksListComponent,
        VendorsListComponent,
        UpdatesListComponent,

        UnitViewComponent,
        ParkingSpotViewComponent,
        LockerViewComponent,
        VehicleViewComponent,
        PetViewComponent,
        BikeRackViewComponent,
        VendorViewComponent,

        VendorsFilterComponent,
        DirectoryArchivedItemsFilterComponent
    ],
    providers: [
        DirectoryService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DirectoryModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/directory/directory.module.ts